import styles from './grid-cell-renderer.module.scss';
import { Box, Skeleton, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import { useEffect, useState } from 'react';
import Fas from './tab-panels/fas/fas';
import Machine from './tab-panels/machine/machine';
import Loan from './tab-panels/loan/loan';
import Account from './tab-panels/account/account';
import Person from './tab-panels/person/person';
import Company from './tab-panels/company/company';
import ActiveUserDetails from './tab-panels/details/details';
import SessionDetails from '../../session-details/session-details';
import { IActiveUser } from '../../_models/active-user';
import { ILoan } from '../../_models/loan';

/* eslint-disable-next-line */
export interface GridCellRendererProps { }

export function ActiveUserDetailsCellRenderer(data: any) {
  const selectedRow: IActiveUser = data.data;
  //if (selectedRow.loanId) return <OldLoanContent loanId={selectedRow.loanId} seatNumber={selectedRow.seatNumber} />
  if (selectedRow.sessionId) return <SessionDetails sessionId={selectedRow.sessionId} />
  return <div></div>
}

// function OldLoanContent(props: {
//   loanId: number,
//   seatNumber: number
// }) {
//   const [loan, setLoan] = useState<ILoan | undefined>(undefined);
//   const [selectedTab, setSelectedTab] = useState<number>(0);

//   const navigateToTabOne = () => setSelectedTab(0);
//   const navigateToTabTwo = () => setSelectedTab(1);
//   const navigateToTabThree = () => setSelectedTab(2);
//   const navigateToTabFour = () => setSelectedTab(3);
//   const navigateToTabFive = () => setSelectedTab(4);
//   const navigateToTabSix = () => setSelectedTab(5);
//   const navigateToTabSeven = () => setSelectedTab(6);

//   useEffect(() => {
//     makeRequest(`license/loaninfo/${props.loanId}`).then(res => setLoan(res));
//   }, []);

//   return (
//     <Box className="p-4">
//       {!loan ? <Skeleton variant="rectangular" animation="wave" width='100%' height={400} /> : <>
//         <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
//           <Tabs
//             value={selectedTab}
//             variant="scrollable"
//             scrollButtons="auto">
//             <Tab label={"Detaljer"} onClick={navigateToTabOne} />
//             <Tab label={"FAS"} onClick={navigateToTabTwo} />
//             <Tab label={"Maskin"} onClick={navigateToTabThree} />
//             <Tab label={"Lån"} onClick={navigateToTabFour} />
//             <Tab label={"Konto"} onClick={navigateToTabFive} />
//             <Tab label={"Person"} onClick={navigateToTabSix} />
//             <Tab label={"Firma"} onClick={navigateToTabSeven} />
//           </Tabs>
//         </Box>
//         {selectedTab === 0 && <ActiveUserDetails loan={loan} seatNumber={props?.seatNumber} />}
//         {selectedTab === 1 && <Fas loan={loan} />}
//         {selectedTab === 2 && <Machine loan={loan} />}
//         {selectedTab === 3 && <Loan loan={loan} />}
//         {selectedTab === 4 && <Account loan={loan} />}
//         {selectedTab === 5 && <Person loan={loan} />}
//         {selectedTab === 6 && <Company loan={loan} />}
//       </>}
//     </Box>
//   );
// }